import Vue from 'vue';
import _ from 'lodash';
import {
  uploadAttachment,
} from '@/api/attachments';
import {
  SET_ATTACHMENT,
} from './mutation-types';

export default {
  state: {
    data: {},
  },
  getters: {
    attachment: (state) => (key) => _.get(state.data, key),
  },
  actions: {
    ACT_UPLOAD_ATTACHMENT: async (context, fd) => uploadAttachment(fd).then((response) => {
      if (response.status === 200) {
        return Promise.resolve(response.data);
      }
      return Promise.reject();
    }),
  },
  mutations: {
    [SET_ATTACHMENT](state, { key, data }) {
      Vue.set(state.data, key, data);
    },
  },
  namespaced: true,
};
